import useWakeLock from './useWakeLock.js';

/**
 * Full-viewport app shell: locks to the dynamic viewport height, paints the
 * brand ground, and keeps the screen awake while a tasting is in progress.
 *
 * Shared by apps/game and apps/game-lite, where it was byte-identical.
 */
export default function FullscreenLayout({ children, className = '' }) {
  // Keep the screen awake during the game on supported devices
  useWakeLock(true);
  return (
    <div
      className={`min-h-[100dvh] h-[100dvh] w-full bg-wine-background text-wine-text-body flex flex-col overflow-y-auto ${className}`}
    >
      {children}
    </div>
  );
}
